import { type FC, useState } from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { RevenueShareReportsListRow } from "@/admin/entities/revenueShareReports";
import {
  AddRevenueShareCorrectionDialog,
  RevenueShareReportColumns,
  formatDay,
} from "@/admin/features/billing";

interface ReportCorrectionsProps {
  report: RevenueShareReportsListRow;
}

/** Статусы, в которых отчёт ещё принимает корректировки (спека §3). */
const EDITABLE_STATUSES = ["draft", "payable"];

export const ReportCorrections: FC<ReportCorrectionsProps> = ({ report }) => {
  const [open, setOpen] = useState(false);

  return (
    <Stack spacing={0.5}>
      {report.corrections.length === 0 ? (
        <Typography variant="body2" color="textSecondary">
          Корректировок нет
        </Typography>
      ) : (
        report.corrections.map((correction, index) => (
          <Stack key={index} spacing={0}>
            <RevenueShareReportColumns.MoneyAmountCell
              amount={correction.amount}
            />
            <Typography variant="caption" color="textSecondary">
              {correction.description} ({formatDay(correction.createdAt)})
            </Typography>
          </Stack>
        ))
      )}

      {EDITABLE_STATUSES.includes(report.status) && (
        <>
          <Button
            size="small"
            onClick={(event) => {
              event.stopPropagation();
              setOpen(true);
            }}
          >
            Добавить корректировку
          </Button>
          <AddRevenueShareCorrectionDialog
            open={open}
            reportId={report.id}
            currency={report.reportAmount.currency}
            contractPaymentId={report.contractPaymentId}
            onClose={() => setOpen(false)}
          />
        </>
      )}
    </Stack>
  );
};
